import Character from '@/characters/models/model';

export default class Token extends Character {
    _token_version = 1;
    /**
     * Canonical display name (kept in sync with the character's _name on spawn).
     * Declared so it survives the constructor's Object.keys copy; left undefined
     * when the source data has no _name so no spurious patch is generated.
     */
    _name: string | undefined = undefined;
    mapId = '';
    pos = {
        q: 0,
        r: 0,
    };
    backgroundColor: string | null = null;
    character: unknown = null;
    icon: string | null = null;
    hidden = false;

    /**
     * Constructor attempts to upgrade old versions of data objects stored in Collection
     */
    constructor(jsonObject?: Record<string, unknown> | null) {
        super(jsonObject);
        if (!jsonObject) return;

        // Character will upgrade its own fields; we'll just upgrade all of our fields.
        const upgraded: Record<string, unknown> = { ...jsonObject };
        switch (jsonObject._token_version) {
            case 0:
                // Change `upgraded` to map any old properties to new ones
                upgraded._token_version = 1;
            // falls through
            case 1:
            // Object upgraded to current version: no further changes needed
            // falls through
            default:
                upgraded._token_version = 1;
                Object.keys(this).forEach((key) => ((this as Record<string, unknown>)[key] = upgraded[key]));
        }
    }
}
